import { devSimulatePing } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { ICharacterHouseClient, WalletType } from '~/shared';
import { IHouseData, IHousesService } from './housesServiceTypes';

export class HousesServiceStub implements IHousesService {
	private readonly house = new Subject<IHouseData>({
		id: '55',
		dayPrice: 1250,
		daysMax: 30,
		daysPaid: 5,
		garagePlaces: 5,
		houseClassColor: '#FF00FF',
		houseClassName: 'Классный дом',
		isLocked: true,
		isOwned: false,
		ownerId: '',
		ownerNickname: '',
		sellPrice: 100000,
		buyPrice: 200000,
	});

	public getCurrentHouse(): IObservable<IHouseData> {
		return this.house;
	}

	public getOwnedHousesIds(): Promise<string[]> {
		console.log('HousesServiceStub:getOwnedHousesIds');
		return Promise.resolve(['55', '123']);
	}

	@devSimulatePing()
	async buy(houseId: string, walletType: WalletType): Promise<void> {
		console.log('HousesServiceStub:buy', houseId, walletType);

		this.house.next({
			id: '55',
			dayPrice: 1250,
			daysMax: 30,
			daysPaid: 7,
			garagePlaces: 5,
			houseClassColor: '#FF00FF',
			houseClassName: 'Классный дом',
			isLocked: false,
			isOwned: true,
			ownerId: 'player-18',
			ownerNickname: 'ProPlayer',
			sellPrice: 100000,
			buyPrice: 200000,
		});
	}

	async getById(houseId: string): Promise<ICharacterHouseClient | null> {
		return {
			buyPrice: 200000,
			characterId: 'player-18',
			createdAt: Date.now(),
			daysPaid: 6,
			houseId,
			lastBillingAt: Date.now(),
		};
	}

	@devSimulatePing()
	async pay(houseId: string, days: number): Promise<void> {
		console.log('HousesServiceStub:pay', houseId, days);

		this.house.next({
			id: '55',
			dayPrice: 1250,
			daysMax: 30,
			daysPaid: days,
			garagePlaces: 5,
			houseClassColor: '#FF00FF',
			houseClassName: 'Классный дом',
			isLocked: false,
			isOwned: true,
			ownerId: 'player-18',
			ownerNickname: 'ProPlayer',
			sellPrice: 100000,
			buyPrice: 200000,
		});
	}

	@devSimulatePing()
	async sell(houseId: string): Promise<void> {
		console.log('HousesServiceStub:sell', houseId);

		this.house.next({
			id: '55',
			dayPrice: 1250,
			daysMax: 30,
			daysPaid: 5,
			garagePlaces: 5,
			houseClassColor: '#FF00FF',
			houseClassName: 'Классный дом',
			isLocked: false,
			isOwned: false,
			sellPrice: 100000,
			buyPrice: 200000,
		});
	}

	@devSimulatePing()
	async inviteToBuyHouse(
		houseId: string,
		characterId: string,
		price: number,
	): Promise<void> {
		console.log('HousesServiceStub:inviteToBuyHouse', {
			houseId,
			otherCharacterId: characterId,
			price,
		});

		this.house.next({
			id: '55',
			dayPrice: 1250,
			daysMax: 30,
			daysPaid: 5,
			garagePlaces: 5,
			houseClassColor: '#FF00FF',
			houseClassName: 'Классный дом',
			isLocked: false,
			isOwned: false,
			ownerId: 'player-18',
			ownerNickname: 'ProPlayer',
			sellPrice: 100000,
			buyPrice: 200000,
		});
	}

	async enterHouse(): Promise<void> {
		console.log('HousesServiceStub:enterHouse');
	}

	async setHouseLocked(houseId: string, isLocked: boolean): Promise<void> {
		console.log('HousesServiceStub:setHouseLocked', houseId, isLocked);
		this.house.next({
			...this.house.getValue(),
			isLocked,
		});
		return Promise.resolve();
	}

	async exitMenu(): Promise<void> {
		console.log('HousesServiceStub:exitMenu');
	}

	getMaxPaidDays(): number {
		return 30;
	}

	getPriceForDay(_houseId: string): number {
		return 500;
	}
}
